import { getUniversityNavLinks } from "@/pages/education/universities/[universityId]/_universityNav";
import MobileNavigation from "./MobileNavigation";

export interface MobileUniversityNavigationProps {
  universityId: string;
}

export default function MobileUniversityNavigation({ universityId }: MobileUniversityNavigationProps) {
  const navLinks = getUniversityNavLinks(universityId);

  return <MobileNavigation links={navLinks} testId="mobile-university-navigation" />;
}
